import React from "react";
import { withStyles } from "@material-ui/core";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRangePicker } from "react-date-range";
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

const styles = (theme) => ({
  selectDate: {
    minHeight: "36px",
    fontSize: "12px",
    color: theme.TextColor,
    backgroundColor: theme.ModalBGColor,
    display: "flex",
    flexDirection: "column-reverse",
    boxShadow: "0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)",

    // Defined Ranges Wrapper
    "& .rdrDefinedRangesWrapper": {
      backgroundColor: theme.ModalBGColor,
      width: "100%",
      border: "none",

      "& .rdrStaticRanges": {
        backgroundColor: theme.ModalBGColor,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        border: "none",
        marginTop: 24,
      },
    },

    "& .rdrMonth": {
      padding: 0,
    },

    // Date Display Styling
    "& .rdrDateDisplayWrapper": {
      backgroundColor: theme.AppBGColor,
      "& .rdrDateDisplayItem": {
        backgroundColor: theme.ModalBGColor,
        borderColor: theme.disabledColor,
        "& input": {
          color: theme.disabledColor,
        }
      },
      "& .rdrDateDisplayItem.rdrDateDisplayItemActive": {
        borderColor: theme.palette.primary.main,
        "& input": {
          color: theme.ColumnHeaderTextColor,
        },
      },
    },

    "& .rdrCalendarWrapper": {
      backgroundColor: theme.ModalBGColor,
    },

    '& .rdrNextPrevButton': {
      background: 'none'
    },
    '& .rdrNextButton i': {
      borderColor: `transparent transparent transparent ${theme.ColumnHeaderTextColor}`
    },
    '& .rdrPprevButton i': {
      borderColor: `transparent ${theme.ColumnHeaderTextColor} transparent transparent`
    },

    // Month & Year Pickers
    "& .rdrMonthAndYearPickers select": {
      color: theme.ColumnHeaderTextColor,
      appearance: "none",
      background: "none",
      backgroundColor: theme.ModalBGColor,
      padding: 10,
    },

    "& .rdrYearPicker::after, & .rdrMonthPicker::after": {
      content: "'\\25BC'",
      color: theme.ColumnHeaderTextColor,
    },

    "& .rdrWeekDay": {
      color: theme.iconColor,
    },

    "& .rdrDayNumber span": {
      color: theme.ColumnHeaderTextColor,
    },

    "& .rdrDayDisabled": {
      background: "none"
    },

    "& .rdrDayDisabled .rdrDayNumber span": {
      backgroundColor: "transparent",
      color: theme.disabledColor,
    },

    "& .rdrDayPassive .rdrDayNumber span": {
      color: theme.disabledColor,
    },

    // Static Range Button Styling
    "& .rdrStaticRange": {
      border: `1px solid ${theme.ColumnHeaderTextColor}`,
      borderRadius: "20px",
      background: theme.ModalBGColor,
      color: theme.ColumnHeaderTextColor,
    },

    "& .rdrStaticRange:hover .rdrStaticRangeLabel, & .rdrStaticRange:focus .rdrStaticRangeLabel":
      {
        background: theme.palette.primary.main,
        color: theme.satelliteViewRouteColor,
        borderRadius: "20px",
      },
  },
});

class DateRange extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    document.addEventListener("keydown", this.hideOnEscape,{capture: true});
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.hideOnEscape);
  }

  hideOnEscape = (e) => {
    if (e.key === "Escape") {
      this.props.handleClose();
    }
  };
  render() {
    const { classes, ...otherProps } = this.props;
    return (
      <ClickAwayListener onClickAway={this.props.handleClose}>
        <DateRangePicker className={classes.selectDate} {...otherProps} />
      </ClickAwayListener>
    );
  }
}

export default withStyles(styles)(DateRange);
